// Dizzplace - podstrona kolekcji: arkusz filtrow na telefonie, harmonijka pytan,
// oraz podmiana listy wzorow BEZ przeladowania strony (Section Rendering API).
// Bez zaleznosci, ES2020.

(() => {
  const TELEFON = '(max-width: 989px)';

  // --- Podmiana listy bez przeladowania -------------------------------------
  // Shopify potrafi oddac sama sekcje (`?section_id=...`), wiec sortowanie,
  // filtry i stronicowanie pobieraja nowa wersje i wymieniaja tylko te
  // fragmenty, ktore sie zmieniaja. Reszta strony (zajawka, pytania) zostaje.
  const KORZEN = () => document.querySelector('[data-coll-section]');

  // Fragmenty wymieniane po kazdej zmianie. Panel filtrow i formularz
  // sortowania tez - inaczej zgubilyby liczniki i zaznaczenia.
  const DO_PODMIANY = ['[data-coll-results]', '[data-filters-panel]', '[data-sort-form]'];

  let licznikZadan = 0;

  const paramsZFormularza = (formularz) => {
    const params = new URLSearchParams();
    new FormData(formularz).forEach((wartosc, klucz) => {
      // Puste widelki cenowe nie maja po co jechac w adresie.
      if (String(wartosc).trim() === '') return;
      params.append(klucz, wartosc);
    });
    params.delete('page');
    return params;
  };

  const aktualizuj = async (params, { przewin = false } = {}) => {
    const korzen = KORZEN();
    if (!korzen) return;

    const sekcja = korzen.dataset.collSection;
    const sciezka = window.location.pathname;
    const zapytanie = params.toString();
    const moje = ++licznikZadan;

    const wyniki = korzen.querySelector('[data-coll-results]');
    wyniki?.setAttribute('data-loading', 'true');

    try {
      const adres = `${sciezka}?${zapytanie}${zapytanie ? '&' : ''}section_id=${sekcja}`;
      const odpowiedz = await fetch(adres);
      if (!odpowiedz.ok) throw new Error(odpowiedz.status);
      const tekst = await odpowiedz.text();

      // Zadanie wyprzedzone przez nowsze - jego wynik jest juz nieaktualny.
      if (moje !== licznikZadan) return;

      const nowy = new DOMParser().parseFromString(tekst, 'text/html');
      /* Podmiana wnetrza kasuje element z fokusem - zapamietujemy pole po nazwie
         i wartosci (np. zaznaczony filtr) i oddajemy mu fokus po podmianie;
         wczesniej klawiatura ladowala na poczatku strony (audyt 27.10.2026). */
      const fokus = document.activeElement;
      const kluczFokusu = fokus && korzen.contains(fokus) && fokus.name
        ? `[name="${CSS.escape(fokus.name)}"]${fokus.value ? `[value="${CSS.escape(fokus.value)}"]` : ''}`
        : null;
      DO_PODMIANY.forEach((selektor) => {
        const stary = korzen.querySelector(selektor);
        const swiezy = nowy.querySelector(selektor);
        if (stary && swiezy) stary.innerHTML = swiezy.innerHTML;
      });
      if (kluczFokusu && !korzen.contains(document.activeElement)) {
        korzen.querySelector(kluczFokusu)?.focus({ preventScroll: true });
      }

      const licznik = korzen.querySelector('[data-coll-count]');
      const licznikNowy = nowy.querySelector('[data-coll-count]');
      if (licznik && licznikNowy) licznik.textContent = licznikNowy.textContent;

      const nowyAdres = zapytanie ? `${sciezka}?${zapytanie}` : sciezka;
      if (nowyAdres !== window.location.pathname + window.location.search) {
        window.history.pushState({ dizzColl: true }, '', nowyAdres);
      }

      if (przewin) {
        const cel = korzen.querySelector('.coll-toolbar');
        if (cel) window.scrollTo({ top: window.scrollY + cel.getBoundingClientRect().top - 120, behavior: 'smooth' });
      }
    } catch (blad) {
      // Gdy cokolwiek pojdzie nie tak, zachowujemy sie jak przed skryptem:
      // zwykle przejscie pod nowy adres.
      window.location.search = params.toString();
    } finally {
      if (moje === licznikZadan) wyniki?.removeAttribute('data-loading');
    }
  };

  // --- Arkusz filtrow wysuwany od dolu (telefon) ----------------------------
  // Na duzym ekranie kolumna filtrow stoi normalnie w ukladzie, wiec caly ten
  // mechanizm jest tam bezczynny.
  const initFiltry = () => {
    const panel = document.querySelector('[data-filters-panel]');
    const otwieracz = document.querySelector('[data-filters-open]');
    if (!panel || !otwieracz || panel.dataset.gotowy === '1') return;
    panel.dataset.gotowy = '1';

    let zaslona = document.querySelector('.coll-scrim');
    if (!zaslona) {
      zaslona = document.createElement('div');
      zaslona.className = 'coll-scrim';
      zaslona.hidden = true;
      panel.parentElement.insertBefore(zaslona, panel);
    }

    const ustaw = (otwarty) => {
      panel.setAttribute('data-open', String(otwarty));
      otwieracz.setAttribute('aria-expanded', String(otwarty));
      document.documentElement.style.overflow = otwarty ? 'hidden' : '';
      if (otwarty) {
        zaslona.hidden = false;
        requestAnimationFrame(() => zaslona.setAttribute('data-open', 'true'));
      } else {
        zaslona.removeAttribute('data-open');
        // Zaslona znika dopiero po przejsciu, zeby nie migala.
        setTimeout(() => { zaslona.hidden = true; }, 280);
      }
    };

    otwieracz.addEventListener('click', () => ustaw(panel.getAttribute('data-open') !== 'true'));
    zaslona.addEventListener('click', () => ustaw(false));

    // Wnetrze panelu jest podmieniane po kazdej zmianie listy, wiec zdarzenia
    // lapiemy na samym panelu, a nie na jego dzieciach.
    panel.addEventListener('click', (zdarzenie) => {
      if (zdarzenie.target.closest('[data-filters-close]')) ustaw(false);
    });

    document.addEventListener('keydown', (zdarzenie) => {
      if (zdarzenie.key === 'Escape' && panel.getAttribute('data-open') === 'true') ustaw(false);
    });

    // Powrot na szeroki ekran z otwartym arkuszem zostawialby zablokowane
    // przewijanie strony, wiec stan czyscimy przy zmianie progu.
    window.matchMedia(TELEFON).addEventListener('change', (zdarzenie) => {
      if (!zdarzenie.matches) ustaw(false);
    });

    window.dizzKolekcjaZamknijFiltry = () => ustaw(false);
  };

  // --- Sortowanie i filtry --------------------------------------------------
  // Wszystko delegowane na dokument, bo formularze sa podmieniane razem z lista.
  const initZdarzenia = () => {
    if (document.documentElement.dataset.collGotowy === '1') return;
    document.documentElement.dataset.collGotowy = '1';

    // Lista wyboru sortowania na desktopie: zmiana od razu przestawia liste.
    // Na telefonie pigulki sortowania siedza w formularzu filtrow i jada
    // razem z nim po "Pokaz wyniki" - jednym zadaniem zamiast dwoma.
    document.addEventListener('change', (zdarzenie) => {
      const sortForm = zdarzenie.target.closest('[data-sort-form]');
      if (sortForm) {
        aktualizuj(paramsZFormularza(sortForm));
        return;
      }

      const filtrForm = zdarzenie.target.closest('[data-filters-form]');
      if (!filtrForm) return;
      // Kolumna filtrow na desktopie nie ma przycisku zatwierdzajacego
      // (projekt go nie przewiduje), wiec zaznaczenie dziala od razu.
      if (zdarzenie.target.name === 'sort_by') return;
      if (window.matchMedia(TELEFON).matches) return;
      aktualizuj(paramsZFormularza(filtrForm));
    });

    document.addEventListener('submit', (zdarzenie) => {
      const formularz = zdarzenie.target.closest('[data-filters-form], [data-sort-form]');
      if (!formularz) return;
      zdarzenie.preventDefault();
      aktualizuj(paramsZFormularza(formularz));
      if (formularz.matches('[data-filters-form]')) window.dizzKolekcjaZamknijFiltry?.();
    });

    // Stronicowanie - ten sam mechanizm, tylko z przewinieciem na gore listy.
    document.addEventListener('click', (zdarzenie) => {
      const odnosnik = zdarzenie.target.closest('[data-coll-results] a[href]');
      if (!odnosnik || zdarzenie.metaKey || zdarzenie.ctrlKey || zdarzenie.shiftKey) return;
      if (!odnosnik.closest('.pagination')) return;
      zdarzenie.preventDefault();
      aktualizuj(new URLSearchParams(new URL(odnosnik.href, window.location.origin).search), { przewin: true });
    });

    // Strzalka "wstecz" po zmianie sortowania wraca do poprzedniej listy.
    window.addEventListener('popstate', () => {
      if (KORZEN()) aktualizuj(new URLSearchParams(window.location.search));
    });
  };

  // Harmonijka pytan dziala tylko na telefonie: od 990 px odpowiedzi stoja
  // obok pytan i sa zawsze widoczne (rozstrzyga o tym arkusz stylow).
  const initPytania = () => {
    document.querySelectorAll('[data-faq-toggle]').forEach((przycisk) => {
      if (przycisk.dataset.gotowy === '1') return;
      przycisk.dataset.gotowy = '1';
      przycisk.addEventListener('click', () => {
        const otwarte = przycisk.getAttribute('aria-expanded') === 'true';
        przycisk.setAttribute('aria-expanded', String(!otwarte));
      });
    });
  };

  // Kolumna filtrow na komputerze jest przyklejona bez wlasnego przewijania.
  // Gdy miesci sie w oknie, stoi 116 px od gory (miejsce na wracajacy
  // naglowek); gdy jest dluzsza, odstep schodzi na minus, tak zeby zatrzymala
  // sie dolem 24 px nad dolem okna - widac wtedy kazdy filtr bez paska.
  const initKolumne = () => {
    const kolumna = document.querySelector('.coll-filters');
    if (!kolumna || kolumna.dataset.kolumnaGotowa === '1') return;
    kolumna.dataset.kolumnaGotowa = '1';
    const ustaw = () => {
      const gora = Math.min(116, window.innerHeight - kolumna.offsetHeight - 24);
      kolumna.style.setProperty('--coll-filtry-gora', `${gora}px`);
    };
    ustaw();
    window.addEventListener('resize', ustaw);
    if ('ResizeObserver' in window) new ResizeObserver(ustaw).observe(kolumna);
  };

  const init = () => {
    initKolumne();
    initFiltry();
    initZdarzenia();
    initPytania();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Edytor motywu podmienia HTML sekcji bez odswiezania strony.
  document.addEventListener('shopify:section:load', () => {
    document.documentElement.dataset.collGotowy = '';
    init();
  });
})();
